<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close(false)"></button>
    </template>
    <template v-slot:body>
      <div class="row custom-body">
        <div class="col-3">
          <img
            src="https://nuvita.blob.core.windows.net/portalapp/inbody_sm.png"
            class="custom-image"
          />
        </div>
        <div class="col">
          <p v-html="show.instructions"></p>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import ZDialog from '@/Components/ZElements/Dialog'
export default {
  name: 'scale-instructions-dialog',
  components: {
    ZDialog,
  },
  props: {
    show: Object,
  },
  data() {
    return {
      modalSize: 'modal-lg',
    }
  },
  emits: ['close', 'saved'],
  computed: {
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Instructions'
      // if (this.show) {
      //   _title = this.show.name
      // }
      return _title
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
  position: relative;
}
.custom-close {
  text-align: right;
  position: absolute;
  right: -20px;
}
.custom-body {
  max-height: 550px;
  overflow-x: auto;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-image {
  width: 100%;
  height: 100%;
}
// .custom-image {
//   width: 112px;
//   height: 174px;
// }
</style>
